import { useQuery } from "@apollo/client";
import { HEALTH_QUERY } from "@/graphql/queries/HealthQuery.ts";
import { getGraphQLURL } from "@/env.ts";

const HealthCheck = () => {
  const { loading, error } = useQuery(HEALTH_QUERY, {
    context: { uri: getGraphQLURL() },
  });
  console.log(loading, error?.networkError);
  return (
    <h1>
      {loading && "Checking..."}
      {!loading &&
        error?.networkError &&
        "statusCode" in error.networkError &&
        "Unhealthy"}
      {!loading &&
        (!error?.networkError || !("statusCode" in error.networkError)) &&
        "Ok"}
    </h1>
  );
};

export default HealthCheck;
